import { Button } from "@/atoms-react/button/Button.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react.tsx";
import { WebAuthnRegisterApi } from "@/features/auth/api-client/webauthn-register-api-client.ts";
import { LimitCredentialInterface } from "@/features/auth/types";
import { useUser } from "@/features/user/hooks/use-user-vue";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
type UpdateWebauthnDeviceProps = {
  onComplete: () => Promise<void>;
  device: LimitCredentialInterface;
};
export const UpdateWebauthnDevice = ({ device, onComplete }: UpdateWebauthnDeviceProps) => {
  const { t } = useTranslation(["pass"]);
  const { user } = useUser();

  const [deviceName, setDeviceName] = useState(device.device_name);
  const [loading, setLoading] = useState(false);

  const short = (() => {
    const firstName = user?.naturalPerson.FirstName?.slice(0, 1);
    const lastName = user?.naturalPerson.LastName?.slice(0, 2) + ".";
    return [firstName, lastName]
      .filter((a) => a && a !== ".")
      .join("")
      .slice(0, 2);
  })();

  const handleUpdateDeviceName = async () => {
    setLoading(true);
    let userActiveCredentials: LimitCredentialInterface[] = [];
    try {
      userActiveCredentials = await WebAuthnRegisterApi.retrieveWebAuthnActiveCredentials();
    } catch (_) {
      console.log("no active credentials");
    }
    try {
      const hasSameDeviceName = userActiveCredentials?.some(
        (userActiveCredential) => userActiveCredential["device_name"] === deviceName
      );
      if (!hasSameDeviceName) {
        const challenge = await WebAuthnRegisterApi.updateDeviceName(device.id, deviceName);
        if (challenge) {
          onComplete();
        }
      } else {
        toast.error(
          t("olkypass.securityPage.webauthnSection.devices.notifications.update.same_name")
        );
      }
    } catch (e) {
      console.log(e);
      toast.error(t("olkypass.securityPage.webauthnSection.devices.notifications.update.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <InputLabel
        onChange={(value) => setDeviceName(value)}
        className="mt-4 mb-3"
        label={`* ${t("olkypass.securityPage.webauthnSection.devices.table.columns.device_name")}`}
        placeholder={`${t(
          "olkypass.securityPage.webauthnSection.devices.placeholder_new_device"
        )} ${short}`}
        required
        value={deviceName}
      />

      <Button
        className="float-right mt-4"
        disabled={!deviceName}
        loading={loading}
        onClick={handleUpdateDeviceName}
      >
        {t("olkypass.general.next")}
      </Button>
    </div>
  );
};
